const getters = {
    getUserList(state){
        return state.userList;
    },
    getUser(state){
        return state.user;
    },
    getLoggedInUser(state) {
        return state.loggedInUser;
    },
    getCustomerList(state) {
        return state.customerList;
    }
}

export default getters;